module.exports = __webpack_public_path__ + "static/usaspirits-gold-faca3a8fa55e9317ce652f506c3ab622.jpg";